import React, { useState, useEffect, useCallback } from "react";
import { Button, Table, Modal, Form, Spinner, Pagination } from "react-bootstrap";
import { insertTipo, updateTipo, getAllTipo, deleteTipo } from "../../../api/AdminApi";

const Tipos = () => {
  const [showModal, setShowModal] = useState(false);
  const [tipos, setTipos] = useState([]);
  const [currentTipo, setCurrentTipo] = useState({ idtipo: null, tipo: "" });
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // === Paginación ===
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const assigmentValue = useCallback(async () => {
    try {
      const response = await getAllTipo();
      setTipos(response);
    } catch (error) {
      console.error("Error fetching tipos:", error);
    }
  }, []);

  const handleShowModal = () => {
    setCurrentTipo({ idtipo: null, tipo: "" });
    setIsEditing(false);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleSave = async () => {
    if (currentTipo.tipo.trim() === "") return;
    setIsLoading(true);
    try {
      if (isEditing) {
        await updateTipo(currentTipo);
      } else {
        await insertTipo({ tipo: currentTipo.tipo });
      }
      await assigmentValue();
      handleCloseModal();
    } catch (error) {
      console.log("No se pudo guardar el tipo. Intente de nuevo.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (tipo) => {
    setCurrentTipo({ idtipo: tipo.idtipo, tipo: tipo.tipo });
    setIsEditing(true);
    setShowModal(true);
  };

  const handleDelete = async (idtipo) => {
    await deleteTipo(idtipo);
    setTipos(tipos.filter((tipo) => tipo.idtipo !== idtipo));
  };

  useEffect(() => {
    assigmentValue();
  }, [assigmentValue]);

  // === Paginación lógica ===
  const paginate = (data, currentPage) =>
    data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  const pageData = paginate(tipos, currentPage);

  const renderPagination = (total, current, setPage) => {
    const totalPages = Math.ceil(total / itemsPerPage);
    if (totalPages <= 1) return null;
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <Pagination.Item key={i} active={i === current} onClick={() => setPage(i)}>
          {i}
        </Pagination.Item>
      );
    }
    return <Pagination className="justify-content-center mt-2">{pages}</Pagination>;
  };

  // === Estilo uniforme de íconos ===
  const btnIconStyle = {
    width: 30,
    height: 30,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 6,
  };

  return (
    <div className="card">
      <div className="card-header border-0 pb-0 d-flex justify-content-between align-items-center">
        <h4 className="card-title mb-0">🏷️ Tipos</h4>
        <Button variant="primary" size="sm" onClick={handleShowModal}>
          + Agregar
        </Button>
      </div>

      <div className="card-body">
        <div className="table-responsive">
          <Table bordered  responsive className="text-center align-middle table-sm mb-0">
            <thead >
              <tr>
                <th style={{ width: "85%" }}>Tipo</th>
                <th style={{ width: "15%" }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {pageData.length > 0 ? (
                pageData.map((tipo, index) => (
                  <tr key={index}>
                    <td style={{ whiteSpace: "pre-wrap" }}>{tipo.tipo}</td>
                    <td>
                      <div className="d-flex justify-content-center gap-2">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          style={btnIconStyle}
                          onClick={() => handleEdit(tipo)}
                          title="Editar"
                        >
                          <i className="fas fa-pen fa-sm"></i>
                        </Button>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          style={btnIconStyle}
                          onClick={() => handleDelete(tipo.idtipo)}
                          title="Eliminar"
                        >
                          <i className="fas fa-trash fa-sm"></i>
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2" className="text-center py-3">
                    No hay tipos registrados
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          {renderPagination(tipos.length, currentPage, setCurrentPage)}
        </div>
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? "Editar Tipo" : "Agregar Tipo"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Nombre del Tipo</Form.Label>
              <Form.Control
                type="text"
                value={currentTipo.tipo}
                onChange={(e) => setCurrentTipo({ ...currentTipo, tipo: e.target.value })}
                placeholder="Ingrese el nombre del tipo"
                disabled={isLoading}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal} disabled={isLoading}>
            Cerrar
          </Button>
          <Button variant="primary" onClick={handleSave} disabled={isLoading}>
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  className="me-2"
                />
                Guardando...
              </>
            ) : isEditing ? (
              "Actualizar"
            ) : (
              "Guardar"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Tipos;
